import { Injectable } from "@angular/core";
import { StoreData } from "./store_data";
import { UserLoginRole } from "../enumeration/roles";

@Injectable({
  providedIn: 'root'
})
export class CheckAccessRoles {

  constructor(private store: StoreData) {
  }

  check(rolesList: any): boolean {
    const roleString = this.store.getRole() || '';

    const userRoles: UserLoginRole[] = roleString
      .split(',')
      .map(r => r.trim() as UserLoginRole);

    // return true if ANY role matches
    return rolesList.some((role: UserLoginRole) => userRoles.includes(role));
  }
}
